import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ApplicationState } from "..";
import { generateTestRequestPayload, callValimate, fetchStatus } from '../adminApi'

import { ValimateResponseDto } from "../../autogenerated/models";

export interface IValimateTestRequestState {
  isLoading: boolean,
  isLoadingStatus: boolean,
  isCalling: boolean,
  requestPayload: string,
  responsePayload?: ValimateResponseDto,
  statusPayload?: ValimateResponseDto,
}

const initialState: IValimateTestRequestState = {
  isLoading: false,
  isLoadingStatus: false,
  isCalling: false,
  requestPayload: "{}",
  responsePayload: {},
  statusPayload: {}
}

export const ValimateTestRequestSlice = createSlice({
  name: "valimateTestRequest",
  initialState,
  reducers: {
    setIsLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },

    setIsLoadingStatus: (state, action:  PayloadAction<boolean>) => {
      state.isLoadingStatus = action.payload;
    },

    setIsCalling: (state, action: PayloadAction<boolean>) => {
      state.isCalling = action.payload;
    },

    setRequestPayload: (state, action: PayloadAction<string>) => {
      state.requestPayload = action.payload
    },

    setResponsePayload: (state, action: PayloadAction<ValimateResponseDto>) => {
      state.responsePayload = action.payload
    },

    setStatusPayload: (state, action: PayloadAction<ValimateResponseDto>) => {
      state.statusPayload = action.payload
    }
  }
})

export default ValimateTestRequestSlice;
export const { actions } = ValimateTestRequestSlice;

export const setIsLoading = (loading: boolean) => {
  return actions.setIsLoading(loading);
}

export const setRequestPayload = (payload: string) => {
  return actions.setRequestPayload(payload)
}

export const createTestRequestPayload = () => (dispatch: any) => {
  dispatch(actions.setIsLoading(true))
  generateTestRequestPayload()
    .then((data: any) => {

     dispatch(actions.setRequestPayload(JSON.stringify(data, null, 4)))
     dispatch(actions.setStatusPayload({}))
     dispatch(actions.setResponsePayload({}))

    })
    .finally(() => {
      dispatch(actions.setIsLoading(false))
    })
}

export const runValimate = () => (dispatch: any, getState: () => ApplicationState) => {
  var state = getState();

  dispatch(actions.setIsCalling(true))
  callValimate(state.valimateTestRequest.requestPayload)
    .then(data => {

      dispatch(actions.setResponsePayload(data))
    })
    .catch(() => {
      // restClient already showed why the call failed
    })
    .finally(() => dispatch(actions.setIsCalling(false)))
}

export const getStatus = (testCaseId: string) => (dispatch: any, getState: () => ApplicationState) => {

  dispatch(actions.setIsLoadingStatus(true));

  fetchStatus(testCaseId)
    .then(data => {
      dispatch(actions.setStatusPayload(data))
    })
    .finally(() => dispatch(actions.setIsLoadingStatus(false)))
}
